import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { parseToUnit } from '@meitu/saas-editor-core/es/utils/unit-kit';
import { RenderMode } from '@meitu/saas-editor-core/es/version-types';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

const CanvasSize: React.FC<{
    imageEditorStyle: boolean;
    handler: () => void;
    currentWidth: number;
    currentHeight: number;
}> = React.memo(({ handler, imageEditorStyle = false, currentWidth, currentHeight }) => {
    const { $t } = useLocaleStore();
    // 图片编辑隐藏功能
    imageEditorStyle && (handler = () => {});
    const [isPickStage, setIsPickStage] = useState(editor.services.frame.getPickActiveFrame());
    const { width: totalWidth, height: totalHeight } = editor.services.frame.getSize();
    const renderMode = editor.services.edgelessCanvas.getRenderMode();
    const isShowCurrentSize = isPickStage || renderMode !== RenderMode.VARIETY;
    const [unit, setUnit] = useState(editor.services.editor.getUnit());

    useEffect(() => {
        const handler = editor.services.editor.onUnitChange(() => {
            setUnit(editor.services.editor.getUnit());
        });
        return () => editor.off(handler);
    }, []);

    useEffect(() => {
        const handle = editor.services.frame.onPickActiveFrameChange((isPickStage) => {
            setIsPickStage(isPickStage);
        });
        return () => {
            editor.off(handle);
        };
    }, []);

    return (
        <React.Fragment>
            <div
                className={classNames('c-background-panel__size', {
                    disabled: imageEditorStyle,
                })}
            >
                <div className="c-background-panel__size-item" onClick={handler}>
                    <span className="c-background-panel__size-value ellipsis">
                        {parseToUnit(isShowCurrentSize ? currentWidth : totalWidth, unit)}
                        {unit}
                    </span>
                    <span className="c-background-panel__size-label">{$t((v) => v.panel.backgroundPanel.width)}</span>
                </div>
                <div className="c-background-panel__size-item" onClick={handler}>
                    <span className="c-background-panel__size-value ellipsis">
                        {parseToUnit(isShowCurrentSize ? currentHeight : totalHeight, unit)}
                        {unit}
                    </span>
                    <span className="c-background-panel__size-label">{$t((v) => v.panel.backgroundPanel.height)}</span>
                </div>
            </div>
        </React.Fragment>
    );
});

export default CanvasSize;
